var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      class: {
        "lang-kr": _vm.lang == _vm.$config.LANG_KOR, //한국
        "lang-en": _vm.lang == _vm.$config.LANG_ENG, //영어
        "lang-mm": _vm.lang == _vm.$config.LANG_MMR, //미얀마
        "lang-kh": _vm.lang == _vm.$config.LANG_CAM, //캄보디아
        "lang-vnd": _vm.lang == _vm.$config.LANG_VTM, //베트남
        "lang-sin": false, //싱가포르
        layout: _vm.$route.meta.layout == "default",
        "motp-content": _vm.$route.meta.layout === undefined
      }
    },
    [
      _c(
        "header",
        { staticClass: "sticky" },
        [
          _c("app-bar", {
            attrs: {
              transparent: _vm.$route.meta.transparent || false,
              goback: _vm.$route.meta.goback,
              nation: _vm.$route.meta.nation || false,
              home: _vm.$route.meta.home || false,
              menu: _vm.$route.meta.menu
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "main" },
        [
          _c("router-view", {
            scopedSlots: _vm._u([
              {
                key: "menuTitle",
                fn: function() {
                  return [
                    _c("div", { staticClass: "title" }, [
                      _c("h2", [_vm._v(_vm._s(_vm.$t(_vm.menuTitle)))])
                    ])
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }